import { Dispatch } from "redux";
import { Link } from "react-router-dom";
import React, { Fragment } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

import * as AuthAction from "stores/auth/AuthAction";

const SwitchProfileItem: React.FC = () => {
  const { t } = useTranslation();

  const dispatch: Dispatch = useDispatch();

  const ProfileSwitchStatus = (): void => {
    dispatch(AuthAction.showProfileSwitchModal());
  };

  return (
    <Fragment>
      <Link
        to={"#"}
        onClick={(event: React.MouseEvent) => {
          event.preventDefault();
          ProfileSwitchStatus();
        }}
      >
        <i className="icofont icofont-exchange" />
        {t("header.header-control.switch-profile")}
      </Link>
    </Fragment>
  );
};

export default SwitchProfileItem;
